"use strict";
/**
 * @module Services.ControlClient
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a SUBSCRIBE_CLIENT and UNSUBSCRIBE_CLIENT request.
 */
var ClientSubscribeRequest = /** @class */ (function () {
    /**
     * Create a new ClientSubscribeRequest instance
     *
     * @param sessionID  the session ID
     * @param selector  the topic selector
     */
    function ClientSubscribeRequest(sessionID, selector) {
        this.sessionID = sessionID;
        this.selector = selector;
    }
    return ClientSubscribeRequest;
}());
exports.ClientSubscribeRequest = ClientSubscribeRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control-client/client-subscribe-request.js
// module id = 1888
// module chunks = 1